/* eslint-disable react/jsx-one-expression-per-line */

import React, { useState } from 'react'

import { ParityLogo } from './assets/ParityLogo';
import { BuildingStatus } from './assets/BuildingStatus';
import { ReactComponent as InfoIcon } from './assets/Infobox_info_icon.svg';

import './ConnectionStatusWidget.less';

const formatDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };



export const ConnectionStatusWidget = ({isSupervisor, isConnected, lastConnected, theme}) => {
  
  const [isInfoOpen, setInfoOpen] = useState(false);


  return (
    <>
      {
        !isSupervisor ?
          <div className="connection-status-widget">
            {
              isInfoOpen ?
                <div className='onboarding'>
                  <div>
                    <p className='onboarding-title'>Connection Status, at a Glance</p>
                    <br /> 
                    Connection Status - This shows whether your building is connected to the Pi system. The connection supports monitoring, alerts, and reports, but <b>does not</b> affect HVAC operation.

                  </div>
                  <div onClick={() => setInfoOpen(() => false)} className='onboarding-cta' data-testid="popup-close-cta">OK</div>
                  <div className="arrow-up" />
                </div>
                :
                null
            }
            <div 
              className={`connection-status connection-status-${theme}`}
            >
              <div className="suspended-box" />
              <div className="status-wrapper">
                <div className='connection-widget' data-testid="building-status-widget">

                  <div style={{height: '23px', width: '23px', paddingTop: '2px'}}>
                    <ParityLogo className='parity-cloud' isConnected={isConnected} theme={theme} />
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', margin: '0 4px'}}>
                    <div className={`connection-line ${isConnected ? 'line-on': 'line-off'}`} />
                    <div className={`${isConnected ? 'connection-meter': 'disconnection-meter'}`} />
                  </div>

                  <div style={{height: '20px', width: '20px'}}>
                    <BuildingStatus isConnected={isConnected} theme={theme} />
                  </div>

                  <div className='status-title'>
                    {isConnected ? ' Connected' : ' Disconnected'}
                  </div>

                </div>
                {
                  !isConnected ?
                    (
                      <div className='status-time'>
                        {`Last Connected: ${formatDate(lastConnected)}`}
                      </div>
                    )
                    :
                    null
                }
              </div>
              <div 
                onClick={() => setInfoOpen(prev => !prev)} 
                className="info-box"
                data-testid="onboarding-popup"
              >
                <InfoIcon color={theme === 'light' ? '#4b4b4b55' : '#14bdc9'} />
              </div>
            </div>
          </div>
        :
        null
      }
        

    </>

  )
}

